import bowser from "bowser"
import { IS_BROWSER, MIN_BROWSERS } from "./environment"

const oldBrowserDetector = () => {
  if (!IS_BROWSER) return false

  if (!bowser.version) return false

  if (bowser.name) {
  const browserName = bowser.name.toLowerCase()
    if (MIN_BROWSERS[browserName]){
      if (
        bowser.version &&
        Number(bowser.version) >= Number(MIN_BROWSERS[browserName])
      ){
        return false
      }else {
        return true
      }
    }
  }

  // default is browser is not an old one
  return false;
}


export default oldBrowserDetector



// WEBPACK FOOTER //
// ./src/AtomicUtils/oldBrowserDetector.js